import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2, Link } from '@zola/zola-ui';

import './ChecklistRemoveOrRevokeModal.less';

const ChecklistRemoveOrRevokeModal = ({ removeOrRevokePartner, onCancel, partnerStatus = {} }) => (
  <div className="checklist__confirmRemoval--container">
    <h2>
      Are you sure you want to {partnerStatus.acceptedAt ? 'remove' : 'uninvite'} this partner?
    </h2>

    <p className="checklist__confirmRemoval--warningCopy">
      Please confirm if you&apos;d like us to deny <strong>{partnerStatus.toEmail}</strong> from
      managing and editing your wedding planning tools.
    </p>
    <div className="checklist__confirmRemoval--footer">
      <ButtonV2
        variant="tertiary"
        onClick={() => removeOrRevokePartner(partnerStatus.uuid, partnerStatus.acceptedAt)}
      >
        Remove
      </ButtonV2>
      <div className="checklist__confirmRemoval--cancel">
        <Link onClick={onCancel}>Cancel</Link>
      </div>
    </div>
  </div>
);

ChecklistRemoveOrRevokeModal.propTypes = {
  onCancel: PropTypes.func,
  removeOrRevokePartner: PropTypes.func,
  partnerStatus: PropTypes.shape({}),
};

ChecklistRemoveOrRevokeModal.defaultProps = {};

export default ChecklistRemoveOrRevokeModal;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistRemoveOrRevokeModal/ChecklistRemoveOrRevokeModal.jsx